var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ComponentsList',{ref:"componentsList",attrs:{"value":_vm.config.specOptions},on:{"edit":_vm.onInput,"editionStart":_vm.editionStart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }